<script>
export default {
  name: "ErrorNotification",
  props: {
    title: { type: String, default: "" },
    subTitle: { type: String, default: "" },
    caption: { type: String, default: "" },
  },
  data() {
    return { isNotificationVisible: true };
  },
  created() {
    // Do not hide the notification if it is an error notification
    // setTimeout(() => (this.isNotificationVisible = false), 3000);
  },
  methods: {
    closeNotification() {
      this.isNotificationVisible = false;
    },
  },
};
</script>

<template>
  <cv-toast-notification
    v-if="isNotificationVisible"
    class="error-notification"
    kind="error"
    :title="title"
    :sub-title="subTitle"
    :caption="caption"
    @close="closeNotification"
  />
</template>

<style scoped>
.error-notification {
  pointer-events: auto;
}
</style>
